import { FC } from 'react';
import { useWizard } from 'react-use-wizard';
import { Button } from '@/components/ui/button';

export type NewUnitWizardFooterProps = {
  interactionDisabled?: boolean;
  skipable?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  onNext?: () => void;
  onSkip?: () => void;
};

// TODO: move wizard component into @/components dir and have footer inside step wrapper so footer doesn't need added for every step
export const NewUnitWizardFooter: FC<NewUnitWizardFooterProps> = ({
  interactionDisabled,
  skipable,
  onCancel,
  onConfirm,
  onNext,
  onSkip,
}) => {
  const { isFirstStep, isLoading, nextStep, previousStep } = useWizard();
  const buttonsDisabled = isLoading || interactionDisabled;

  return (
    <div className="mt-16 flex flex-row justify-end gap-4 border-t border-gray-900/10 p-4">
      {isFirstStep && onCancel ? (
        <Button
          disabled={buttonsDisabled}
          onClick={onCancel}
          variant="secondary"
        >
          Cancel
        </Button>
      ) : (
        <Button
          disabled={buttonsDisabled}
          onClick={previousStep}
          variant="secondary"
        >
          Back
        </Button>
      )}
      {skipable && (
        <Button
          disabled={buttonsDisabled}
          onClick={onSkip ?? nextStep}
          variant="secondary"
        >
          Skip for now
        </Button>
      )}
      {onConfirm ? (
        <Button
          disabled={buttonsDisabled}
          onClick={onConfirm}
          variant="primary"
        >
          Confirm
        </Button>
      ) : (
        <Button
          disabled={buttonsDisabled}
          onClick={onNext ? onNext : nextStep}
          variant="primary"
        >
          Next
        </Button>
      )}
    </div>
  );
};
